// src/utils/buildFloawchUrl.js
// Builds a Floawch destination URL with Meta Ads identifiers attached so
// the conversion on Floawch can be tied back to the original ad click.

const readCookie = (name) => {
  if (typeof document === 'undefined') return null;
  const m = document.cookie.match(new RegExp('(^|;\\s*)' + name + '=([^;]+)'));
  return m ? decodeURIComponent(m[2]) : null;
};

const readQueryParam = (name) => {
  if (typeof window === 'undefined') return null;
  const params = new URLSearchParams(window.location.search);
  return params.get(name);
};

export function buildFloawchUrl(basePath = '/workouts', extraParams = {}) {
  const base = `https://hl-project.nl${basePath}`;
  const params = new URLSearchParams();

  Object.entries(extraParams).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      params.set(key, value);
    }
  });

  const fbclid = readQueryParam('fbclid');
  const fbp = readCookie('_fbp');
  const fbc = readCookie('_fbc');

  if (fbclid) params.set('fbclid', fbclid);
  if (fbp) params.set('_fbp', fbp);
  if (fbc) params.set('_fbc', fbc);

  const qs = params.toString();
  return qs ? `${base}?${qs}` : base;
}
